export type CornerSingleSidePOIPoiType = (typeof CornerSingleSidePOIPoiType)[keyof typeof CornerSingleSidePOIPoiType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CornerSingleSidePOIPoiType = {
    CornerSingleSidePOI: 'CornerSingleSidePOI'
} as const;
